import { Permiso_recepcion } from './../../../models/permisos_recepcion.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-permiso-recepciones',
  templateUrl: './permiso-recepciones.component.html',
  styleUrls: ['./permiso-recepciones.component.css'],
  providers: [FormService]
})
export class PermisoRecepcionesComponent {
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

  public rows = [];
  public actualRow;
  public Permiso_recepcion: Permiso_recepcion;
  public formulario;
  public temp_clasif;
  public matcher = new FormService();

  constructor(private dialog: MatDialog) {

    this.formulario = new FormGroup({
      permiso: new FormControl(''),
      numero: new FormControl(''),
      fecha: new FormControl(''),
      superficie: new FormControl(''),
      certificado: new FormControl(''),
      fechacert: new FormControl(''),
    })
    if (!JSON.parse(localStorage.getItem("Permiso_recepcion"))) {
      localStorage.setItem("Permiso_recepcion", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("Permiso_recepcion"));

    }
    this.Permiso_recepcion = {
      permiso: "",
      numero: "",
      fecha: "",
      superficie: "",
      certificado: "",
      fechacert: ""
    };
    this.temp_clasif = {
      permiso: "",
      numero: "",
      fecha: "",
      superficie: "",
      certificado: "",
      fechacert: ""
    };
  }

  add_clasificacion() {


    this.actualRow = localStorage.getItem("Permiso_recepcion");
    this.rows = JSON.parse(this.actualRow);

    if (!this.formulario.value.permiso || !this.formulario.value.numero  || !this.formulario.value.fecha  || !this.formulario.value.superficie  || !this.formulario.value.certificado || !this.formulario.value.fechacert) {
      console.log("no se ingresaron datos");
      this.dialog.open(this.openModalNODATA);

    } else {
      this.rows = this.rows.concat({
        permiso: this.formulario.value.permiso,
        numero: this.formulario.value.numero,
        fecha: this.formulario.value.fecha,
        superficie: this.formulario.value.superficie,
        certificado: this.formulario.value.certificado,
        fechacert: this.formulario.value.fechacert

      })
      localStorage.setItem("Permiso_recepcion", JSON.stringify(this.rows));
      this.formulario.reset();
    }




  }

  get_clasificacion(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.temp_clasif.id = id;
        this.temp_clasif.permiso = this.rows[x].permiso;
        this.temp_clasif.numero = this.rows[x].numero;
        this.temp_clasif.fecha = this.rows[x].fecha;
        this.temp_clasif.superficie = this.rows[x].superficie;
        this.temp_clasif.certificado = this.rows[x].certificado;
        this.temp_clasif.fechacert = this.rows[x].fechacert;

        this.dialog.open(this.openModal);
      }
    }
  }

  cleanData() {
    this.temp_clasif = { 
      permiso: "",
      numero: "",
      fecha: "",
      superficie: "",
      certificado: "",
      fechacert: ""
     };
  }

  saveclasificacion() {
    var id = this.temp_clasif.id;
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("Permiso_recepcion", JSON.stringify(this.rows));

        $("#clasif_modal").modal("hide");
        this.actualRow = localStorage.getItem("Permiso_recepcion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
          permiso: this.temp_clasif.permiso,
          numero: this.temp_clasif.numero,
          fecha: this.temp_clasif.fecha,
          superficie: this.temp_clasif.superficie,
          certificado: this.temp_clasif.certificado,
          fechacert: this.temp_clasif.fechacert
        })
        localStorage.setItem("Permiso_recepcion", JSON.stringify(this.rows));
        this.temp_clasif = { 
          permiso: "",
          numero: "",
          fecha: "",
          superficie: "",
          certificado: "",
          fechacert: ""
        };
        this.dialog.closeAll();
      }
    }
  }

  delete_clasificacion(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("Permiso_recepcion", JSON.stringify(this.rows));
      }
    }
    this.actualRow = localStorage.getItem("Permiso_recepcion");
    this.rows = JSON.parse(this.actualRow);
  }

}
